document.addEventListener('DOMContentLoaded', () => {
	const {
		popupEnabled, popupDismissalDays, parameterOnlyPopup, popupParameter, referrerUrl,
	} = window.cePopupSettings;
	const modal = document.getElementById('ce-popup-modal');

	if (popupEnabled && modal) {
		const url = new URL(window.location.href);
		const urlParams = url.searchParams;
		const closeBtn = document.getElementById('close-btn');
		const referredBy = document.referrer;
		const { body } = document;

		const timeKeepNotificationBarClosed = popupDismissalDays * 24 * 60 * 60 * 1000;
		const lastClosedTime = localStorage.getItem('ceHNPopupModalClosedTime');
		const timeNnow = new Date().getTime();

		const openPopup = () => {
			modal.style.display = 'flex';
			body.classList.add('no-scroll');
		};

		if (parameterOnlyPopup && popupParameter !== '') {
			if (urlParams.get(popupParameter)) {
				openPopup();
			}
		} else if (referrerUrl && referredBy !== '') {
			const referredByHostname = new URL(referredBy).hostname;

			if (typeof referredByHostname !== 'undefined' && referredByHostname === referrerUrl) {
				openPopup();
			}
		} else if (!lastClosedTime || (timeNnow - lastClosedTime) > timeKeepNotificationBarClosed) {
			openPopup();
		}

		closeBtn.addEventListener('click', () => {
			modal.style.display = 'none';
			body.classList.remove('no-scroll');
			localStorage.setItem('ceHNPopupModalClosedTime', timeNnow);

			let newUrl = `${url.origin}${url.pathname}`;
			urlParams.delete(popupParameter);
			if (urlParams.size > 0) {
				newUrl = `${url.origin}${url.pathname}?${urlParams.toString()}`;
			}
			window.history.replaceState({}, '', newUrl);
		});
	}
});
